import { combineReducers } from 'redux';
import loginReducers from './LoginScreen/LoginStore/loginReducers';

export const reducers = combineReducers({
  ...loginReducers,
});

export type RootState = ReturnType<typeof reducers>;
